import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  BESelectedArrayStepOne: [],
  BESelectedArrayStepTwo: [],
  BEStepThree: { work: "", isVisibleManager: false, personalGrowth: "" },
  BEStepFour: { work: "", isVisibleManager: false, personalGrowth: "" },
  BEStepFive: { work: "", isVisibleManager: false, personalGrowth: "" },
  showComplition: false,
  stepNo: 0,
  visibleEditOption: false,
};

const weaknessSlice = createSlice({
  name: "weakness",
  initialState,
  reducers: {
    saveSelectedWeaknessesStepOne(state, action) {
      state.BESelectedArrayStepOne = action.payload;
    },
    saveSelectedWeaknessesStepTwo(state, action) {
      state.BESelectedArrayStepTwo = action.payload;
    },
    saveStepThree(state, action) {
      state.BEStepThree = action.payload;
    },
    saveStepFour(state, action) {
      state.BEStepFour = action.payload;
    },
    saveWeaknessComplition(state, action) {
      state.showComplition = action.payload;
    },
    saveStepNo(state, action) {
      state.stepNo = action.payload;
    },
    saveVisibleEditOption(state, action) {
      state.visibleEditOption = action.payload;
    },
  },
});

export const {
  saveSelectedWeaknessesStepOne,
  saveSelectedWeaknessesStepTwo,
  saveStepThree,
  saveStepFour,
  saveStepFive,
  saveWeaknessComplition,
  saveStepNo,
  saveVisibleEditOption,
} = weaknessSlice.actions;

export default weaknessSlice.reducer;
